import * as actionTypes from "./actionTypes";

// Wallet
export const getWalletTransactionList = data => {
  return {
    type: actionTypes.GET_WALLET_TRANSACTION_LIST,
    data
  };
};
export const getWalletTransactionListSuccess = data => {
  return {
    type: actionTypes.GET_WALLET_TRANSACTION_LIST_SUCCESS,
    data
  };
};
export const getWalletPaymentCode = () => {
  return {
    type: actionTypes.GET_WALLET_PAYMENT_CODE
  };
};
export const getWalletPaymentCodeSuccess = data => {
  return {
    type: actionTypes.GET_WALLET_PAYMENT_CODE_SUCCESS,
    data
  };
};

// Wallet Rebate
export const getRebateTransaction = data => {
  return {
    type: actionTypes.GET_WALLET_REBATE_LIST,
    data
  };
};
export const getRebateTransactionSuccess = data => {
  return {
    type: actionTypes.GET_WALLET_REBATE_LIST_SUCCESS,
    data
  };
};

// Top Up
export const loadWalletTopUp = data => {
  return {
    type: actionTypes.LOAD_WALLET_TOP_UP,
    data
  };
};
export const loadWalletTopUpSuccess = () => {
  return {
    type: actionTypes.LOAD_WALLET_TOP_UP_SUCCESS
  };
};
export const loadWalletTopUpFail = () => {
  return {
    type: actionTypes.LOAD_WALLET_TOP_UP_FAIL
  };
};
